export default __webpack_public_path__ + "static/media/peer-screenshots.4b2da908.jpg";